<!-- eslint-disable -->
<template>
  <div id="service">
    <div class="row align-items-start pb-2">
        <div class="col-1">
          <label class="form-check-label" >Nur Sms</label>
        </div>
        <div class="col-1">
          <input class="form-check-input" type="checkbox" v-bind:checked="testmode" @change="handleTestMode" id="flexCheckDefault" />
        </div>
        <div class="col-10" />
    </div>
    <div class="row align-items-start pb-2">
        <div clas="col-12">
        <Grid
          ref="grid"
          :style="{ height: '300px' }"
          :data-items="filteredData"
          :selected-field="selectedField"
          :columns="columns"
          :filterable="true"
          :filter="filter"
          :sortable="true"
          :sort="sort"
          :edit-field="'inEdit'"
          @filterchange="filterChange"
          @selectionchange="onSelectionServiceChange"
          @headerselectionchange="onHeaderSelectionServiceChange"
          @rowclick="onRowClick"       
          @cellclick="onCellClick"
          @sortchange="sortChange"
          @itemchange="onItemChange"
          :filter-cell-render="filterRender"
        >
          <template v-slot:filterSlotTemplate="{ props, methods }">
            <div>
              <input
                type="text"
                :value="props.value"
                @input="
                  (ev) => {
                    props.onChange({
                      operator: 'contains',
                      field: props.field,
                      value: ev.target.value,
                      syntheticEvent: ev,
                    });
                  }
                "
                style="width: 85px"
              />
              <button
                @click="
                  (ev) => {
                    props.onChange({
                      operator: '',
                      field: '',
                      value: '',
                      event: ev,
                    });
                  }
                "
              >
                Clear
              </button>
            </div>
          </template>
          >
        </Grid>
      </div>
    </div>
    <div class="row align-items-end justify-items-start pb-2">
        <div class="col-2">
          Ausgewählte Geräte:  - {{selectedDevices}} -
        </div>
        <div class="col-2 pre__wrap">
          Ausgewählte Services - {{selectedServiceCommands}} -
        </div>
        <div class="col-2">          
           <button
              type="button"
              @click.prevent="onButtonServiceClick"
              class="btn btn-outline-primary"
              :disabled="isServiceInProgress"
            >
            {{btnText}}
          </button>
        </div>
         <div class="col-2">
          Verarbeitete Sendungen:  - {{processedDeviceTasks}} -
        </div>
        <div class="col-4" />
    </div>
  </div>
</template>
<script>
import { Grid } from "@progress/kendo-vue-grid";
import "@progress/kendo-theme-default/dist/all.css";
import { filterBy, orderBy } from "@progress/kendo-data-query";
import { apiPost } from "@/services/api/fetchapi";
import { UserStore } from "@/store/modules/userstore"


export default {
  name: "Service",
  components: {
    Grid: Grid,
  },
  props: ["MonitoringName"],
  data: function () {
    return {
      btnText: "Ausführen",
      isServiceInProgress: false,
      processedDeviceTasks: 0,
      selectedDevices: 0,
      selectedServiceCommands: "",
      editField: undefined,
      changes: false,
      testmode: false,
      filter: {},
      sort: [{ field: "prozessTyp", dir: "asc" },{ field: "prozessName", dir: "asc" },{ field: "reihenfolgeVerarbeitung", dir: "asc" }],
      selectedField: "selected",
      filteredData: [],
      originData: [],
      staticColumns: [ 
        { field: 'idAutomatischerProzess', title: 'IdAutomatischerProzess', filterable: false, hidden: true },
        { field: 'fkMandant', title: 'fkMandant', filterable: false, hidden: true },
        { field: 'fkBereich', title: 'fkBereich', filterable: false, hidden: true },
        { field: 'fkGeraeteTyp', title: 'fkGeraeteTyp', filterable: false, hidden: true },
        { field: 'nameGeraetTyp', title: 'Ger. Typ', filterCell: 'filterSlotTemplate', width:'150px', hidden: true  },
        { field: 'prozessTyp', title: 'ProzessTyp', filterCell: 'filterSlotTemplate', width:'150px' , filterable: false},
        { field: 'prozessName', title: 'ProzessName', filterCell: 'filterSlotTemplate', width:'250px' },
        { field: 'sendungZielGeraeteAuflistung', title: 'SendungZielGeraeteAuflistung', filterCell: 'filterSlotTemplate', width:'300px', hidden: true  },
        { field: 'sendungEingangBedingung', title: 'SendungEingangBedingung', filterCell: 'filterSlotTemplate', width:'300px'  , hidden: true  },
        { field: 'automatischeZielSendung', title: 'AutomatischeZielSendung', filterCell: 'filterSlotTemplate', width:'300px' },
        { field: 'verzoegerteAusfuehrungInSekunden', title: 'Warte', filterCell: 'filterSlotTemplate', width:'75px' , filterable: false},
        { field: 'warteAufFreigabe', title: 'WarteAufFreigabe', filterCell: 'filterSlotTemplate', width:'300px', hidden: true  },
        { field: 'warteAufFreigabeTimeoutInSekunden', title: 'WarteAufFreigabeTimeoutInSekunden', filterCell: 'filterSlotTemplate', width:'300px', hidden: true  },
        { field: 'warteAufVorgaenger', title: 'WarteAufVorgaenger', filterCell: 'filterSlotTemplate', width:'300px', hidden: true  },
        { field: 'reihenfolgeVerarbeitung', title: 'Sort', filterCell: 'filterSlotTemplate', width:'60px' , filterable: false},
        { field: 'isSms', title: 'IsSms', filterCell: 'filterSlotTemplate', width:'300px', hidden: true  },
        { field: 'sendungInhalt1', title: 'Parameter -1-', filterCell: 'filterSlotTemplate', width:'300px' },
        { field: 'sendungInhalt2', title: 'SendungInhalt2', filterCell: 'filterSlotTemplate', width:'300px' , hidden: true  },
        { field: 'sendungInhalt3', title: 'SendungInhalt3', filterCell: 'filterSlotTemplate', width:'300px' , hidden: true },
        { field: 'sendungInhalt4', title: 'SendungInhalt4', filterCell: 'filterSlotTemplate', width:'300px' , hidden: true },
        { field: 'sendungInhalt5', title: 'SendungInhalt5', filterCell: 'filterSlotTemplate', width:'300px' , hidden: true },
        { field: 'sendungInhalt6', title: 'SendungInhalt6', filterCell: 'filterSlotTemplate', width:'300px' , hidden: true },
        { field: 'sendungInhalt7', title: 'SendungInhalt7', filterCell: 'filterSlotTemplate', width:'300px' , hidden: true },
        { field: 'sendungInhalt8', title: 'SendungInhalt8', filterCell: 'filterSlotTemplate', width:'300px' , hidden: true },
        { field: 'sendungInhalt9', title: 'SendungInhalt9', filterCell: 'filterSlotTemplate', width:'300px' , hidden: true },
        { field: 'sendungInhalt10', title: 'SendungInhalt10', filterCell: 'filterSlotTemplate', width:'300px' , hidden: true },
        ]
    };
  },
  computed: {
    areAllSelected() {
      return (
        this.filteredData.findIndex((item) => item.selected === false) === -1
      );
    },
    columns() {
      return [
        {
          field: "selected",
          width: "50px",
          filterable: false,
          headerSelectionValue: this.areAllSelected,
        },
        ...this.staticColumns,
      ];
    },
  },
  watch: {
    MonitoringName (val, oldVal) {
      if (val !== oldVal) this.getData()
    }
  },
  methods: {
    handleTestMode() {
      this.testmode = !this.testmode
    },
    onButtonServiceClick() {
      this.isServiceInProgress = true
      this.btnText = "Verarbeitung läuft..."
      this.execService()
    },
    async execService() {
      this.processedDeviceTasks = 0
      const selectedServices = this.$store.getters["servicestore/getDataSet"]
      const temp = await apiPost("ComponentView/generateServiceMessages", {
        userId: this.$store.getters["userstore/getUser"],
        nurSms: this.testmode,
        geraete: this.getDevices(),
        serviceSequence: this.getServices()
      });
      try {
        this.processedDeviceTasks = temp.anzahl
        this.isServiceInProgress = false
        this.btnText = "Ausführen"
      }
      catch(e) {
        console.log(e)
      }      
    },
    onHeaderSelectionServiceChange(event) {
      let checked = event.event.target.checked;
      this.filteredData = this.filteredData.map((item) => {
        return { ...item, selected: checked };
      });
      const selectedServices = this.$store.getters["servicestore/getDataSet"]
      selectedServices.services = []
      this.selectedServiceCommands = ""
      let div = ""
      this.filteredData.forEach((item) => {
        if (item.selected === true) {
          selectedServices.services.push(item);
          this.selectedServiceCommands = this.selectedServiceCommands + div + item.automatischeZielSendung;
          div = " ";
        }
      });
      this.$store.commit("servicestore/setDataSet",selectedServices)
    },
    onSelectionServiceChange(event) {
      this.selectionChanged(event)
    },
    selectionChanged( event ) {
      event.dataItem[this.selectedField] = !event.dataItem[this.selectedField];
      const selectedServices = this.$store.getters["servicestore/getDataSet"]
      selectedServices.services = [];
      let div = ""
      this.selectedServiceCommands = ""
      this.filteredData.forEach((item) => {
        if (item.selected === true) {
          selectedServices.services.push(item);
          this.selectedServiceCommands = this.selectedServiceCommands + div + item.automatischeZielSendung;
          div = " ";
        }
      });
      this.$store.commit("servicestore/setDataSet",selectedServices)
    },

    onRowClick(event) {
      this.selectionChanged(event)
    },
    onCellClick(e) {
      this.selectionChanged(e)
      if (e.dataItem.inEdit && e.field === this.editField) {
        return;
      }
      this.editField = e.field;
      e.dataItem.inEdit = e.field;
    },
    onItemChange(e) {
      e.dataItem[e.field] = e.value;
      this.changes = true;
    },
    filterChange: function (ev) {
      this.filter = ev.filter;
      this.filteredData = filterBy(this.originData, this.filter);
    },
    filterRender: function (h, defaultRendering, props, change) {
      return defaultRendering;
    },
    sortChange: function (e) {
      this.sort = e.sort;
      this.filteredData = orderBy(this.originData, this.sort);
    },
    getAreas() {
      const areaInfo = this.$store.getters["areastore/getDataSet"];
      const areas = [];
      for (let i = 0; i < areaInfo.areas.length; i++) {
        areas.push(areaInfo.areas[i]["idBereich"]);
      }
      return areas
    },
    getDevices() {
      const deviceInfo = this.$store.getters["devicestore/getDataSet"];
      const devices = [];
      for (let i = 0; i < deviceInfo.devices.length; i++) {
        devices.push(deviceInfo.devices[i]["idGeraet"]);
      }
      return devices
    },
    getServices() {
      const serviceInfo = this.$store.getters["servicestore/getDataSet"];
      const services = [];
      for (let i = 0; i < serviceInfo.services.length; i++) {
        services.push(serviceInfo.services[i]);
      }
      return services
    },
    async getData() {
      const serviceInfo = this.$store.getters["servicestore/getDataSet"];
      const services = [];
      for (let i = 0; i < serviceInfo.services.length; i++) {
        services.push(serviceInfo.services[i]);
      }
      const temp = await apiPost("ComponentView/viewKomponenteService", {
        userId: this.$store.getters["userstore/getUser"],
        MonitoringName: this.MonitoringName
      });
      this.filteredData = temp.map((item) => {
        return { ...item, selected: false };
      });
      this.originData = temp.map((item) => {
        return { ...item, selected: false };
      });
    },
  },
  created() {
    this.isServiceInProgress = false
    this.btnText = "Ausführen"
    this.getData();
    this.processedDeviceTasks = 0
    try {
      const deviceInfoTemp = this.$store.getters["devicestore/getDataSet"];
      this.selectedDevices = deviceInfoTemp.devices.length
    } catch(e) {
      console.log(e)
    }


    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if ( mutation.type === "devicestore/setDataset") {
        this.processedDeviceTasks = 0
        this.selectedDevices = 0
        try {
          const deviceInfo = this.$store.getters["devicestore/getDataSet"];
          this.selectedDevices = deviceInfo.devices.length
        } catch(e) {
          console.log(e)
        }
      }
    });
  },
  beforeUnmount() {
    this.unsubscribe();
  },
};
</script>
<style scoped>
.k-grid {
  font-size: 12px !important;
}
.pre__wrap {
  white-space: pre-wrap !important;  
}
</style>